import { type ResultOf } from '@graphql-typed-document-node/core'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { graphql } from '~/gql'
import { exists } from '~/utils'

export const pathKey = 'timeSeriesAnalysis' satisfies PathKey

export const tableChartTypes = ['chart', 'table'] as const

export type TableChartType = (typeof tableChartTypes)[number]

export const tableChartTypeLabelMap = {
  chart: 'graph',
  table: 'table',
} as const satisfies Record<TableChartType, string>

const surveyFragment = graphql(`
  fragment TimeSeriesAnalysisPage_GetSurveyLabel_Survey on Survey {
    title
    metadata {
      surveyStartDate {
        year
        month
      }
    }
  }
`)

export const getSurveyLabel = (survey: ResultOf<typeof surveyFragment>) =>
  exists(survey.metadata?.surveyStartDate)
    ? `${survey.metadata?.surveyStartDate?.year}/${survey.metadata?.surveyStartDate?.month}`
    : `(${
        4 < survey.title.length
          ? `${survey.title.slice(0, 3)}...`
          : survey.title
      })`

export type SeriesItem = {
  data: (number | null)[]
  name: string
  isLabelVisible: boolean
}

export type ScrollHash = string

export type DataItem = {
  percentage: number | null
  estimatedPopulation: number | null
}

export const getDatum = <T extends DataItem>(
  items: T[],
  finder: (item: T) => boolean,
  isPercentage: boolean,
) => {
  const item = items.find(finder)

  if (!exists(item)) {
    return null
  }

  return isPercentage ? item.percentage : item.estimatedPopulation
}
